import type { BillingClassBillType } from '@catalyst-psa/shared';

export const BILL_TYPE_LABELS: Record<BillingClassBillType, string> = {
  bill: 'Bill',
  no_charge: 'No charge',
  no_bill: 'No bill',
};
